import { useContext, useEffect, useState } from "react";
import { useOutletContext } from "react-router";
import styled, { css } from "styled-components";
import Styles from "../../../../OBJRep/Styles";
import { fetchThemesWithFilters } from "../../../../services/PriceThemeService";
import Button from "../../../sharable/ActionButton";
import usePaginatedResources from "../../../sharable/hooks/usePaginatedResources";
import Loading from "../../../sharable/Loading";
import PremiumContentProtectiveLayer from "../../../sharable/PremiumContentProtectiveLayer";
import FilterList from "../../../sharable/ThemeFilter";
import {
  DEFAULT_PRICE_STYLE_SERVER_LOCATION,
  ROUGHLY_ROUNDED_PRICE_STYLE,
  ROUNDED_PRICE_STYLE,
} from "../../CanvasViewer/EncarteConstants";
import WorkspaceContext from "../../WorkspaceContext";
import { MenuTitle } from "../Toolbar";

const Container = styled.div`
  position: relative;
  width: 100%;
  height: min-content;
  h2 {
    text-transform: capitalize;
  }
  ${({ isAccountPremium }) =>
    !isAccountPremium &&
    css`
      overflow: hidden;
      main {
        filter: blur(3px);
      }
    `}
`;

const PricesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-items: center;
  gap: 1rem;
  margin-top: 2rem;
  position: relative;
`;

export const PriceImage = styled.div`
  ${({ imageUrl }) => {
    return css`
      background-image: url("${imageUrl}");
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      height: 100%;
      width: 100%;
    `;
  }}
`;

const NoModelFoundSpan = styled.span`
  display: block;
  font-size: 1.4rem;
  text-align: center;
  grid-column: 1 / 3;
  width: 100%;
`;

// TODO: Review Styles OBJ Rep. "Why all properties are still there?"
const styles1 = Styles();
const styles2 = Styles();
const styles3 = Styles();
styles1.priceStyle = DEFAULT_PRICE_STYLE_SERVER_LOCATION;
styles2.priceStyle = ROUNDED_PRICE_STYLE;
styles3.priceStyle = ROUGHLY_ROUNDED_PRICE_STYLE;

export default function PricesMenuView({
  updateProductStyle,
  selectedProduct,
}) {
  const { isAccountPremium, accountStatus } = useOutletContext();
  const [currentPriceStyle, setCurrentPriceStyle] = useState();
  const { token } = useOutletContext();
  const { priceThemesSearchResult, onPriceThemesSearchResultChange } =
    useContext(WorkspaceContext);

  const [filtersBuiltParams, setFiltersBuiltParams] = useState("color=RED");

  const onLoadFirstThemes = async ({ filters }) => {
    return await fetchThemesWithFilters(token, filters, 0, 10);
  };

  const onLoadMoreThemes = async (nextPage, { filters }) => {
    return await fetchThemesWithFilters(token, filters, nextPage, 10);
  };
  const { loading, hasNextPage, loadInitialResources, loadMoreResources } =
    usePaginatedResources(
      onLoadFirstThemes,
      onLoadMoreThemes,
      onPriceThemesSearchResultChange,
      priceThemesSearchResult.resources,
      priceThemesSearchResult.currentPage,
      priceThemesSearchResult.hasNextPage,
    );

  useEffect(() => {
    if (selectedProduct && selectedProduct.styles.priceStyle)
      setCurrentPriceStyle(selectedProduct.styles.priceStyle);
    else setCurrentPriceStyle(DEFAULT_PRICE_STYLE_SERVER_LOCATION);
  }, [selectedProduct]);

  const handlePriceChange = (style) => {
    setCurrentPriceStyle(style.url);
    updateProductStyle("priceStyle", style.url);
    updateProductStyle("priceStyleTmp", style.urlTmp);
  };

  const handleApplyFilters = (filterParams) => {
    setTimeout(() => {
      setFiltersBuiltParams(filterParams);
      loadInitialResources({
        filters: filterParams,
      });
    }, 200);
  };

  /**
   * Effect to load initial themes based on the theme name input.
   */
  useEffect(() => {
    loadInitialResources({ filters: filtersBuiltParams });
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <Container isAccountPremium={isAccountPremium}>
        <MenuTitle>Etiquetas</MenuTitle>

        <FilterList
          filters={{
            color: [
              { label: "Vermelho", value: "RED" },
              { label: "Azul", value: "BLUE" },
              { label: "Verde", value: "GREEN" },
              { label: "Amarelo", value: "YELLOW" },
              { label: "Laranja", value: "ORANGE" },
              { label: "Roxo", value: "PURPLE" },
              { label: "Preto", value: "BLACK" },
              { label: "Branco", value: "WHITE" },
              { label: "Cinza", value: "GRAY" },
              { label: "Marrom", value: "BROWN" },
            ],
          }}
          filterLabels={{
            color: "Cores",
          }}
          onApplyFilters={handleApplyFilters}
          filterMultiSelect={{ color: false }}
          initialSelected={{ color: ["RED"] }}
          filterButtonText="filtrar etiquetas"
        />
        {filtersBuiltParams &&
        !loading &&
        priceThemesSearchResult?.resources?.length === 0 ? (
          <NoModelFoundSpan>
            Nenhuma etiqueta encontrada para os filtros selecionados ;({" "}
            <br></br>
          </NoModelFoundSpan>
        ) : (
          <PricesWrapper>
            {loading && (
              <Loading $NoBg color="#fff" txt={"Carregando etiquetas"} />
            )}
            {priceThemesSearchResult?.resources?.length > 0 &&
              priceThemesSearchResult.resources.map((price) => (
                <PriceCard
                  key={price.url}
                  imageUrl={price.urlTmp}
                  onClick={() => handlePriceChange(price)}
                  isIncludedInPlan={
                    isAccountPremium || !price.isPremiumResource
                  }
                  showPremiumTag={
                    (!isAccountPremium && price.isPremiumResource) ||
                    (price.isPremiumResource && accountStatus.onTrial)
                  }
                />
              ))}
            {hasNextPage && !loading && (
              <Button
                text={"Carregar mais preços"}
                $NoBgColor
                color="#fff"
                action={() =>
                  loadMoreResources({ filters: filtersBuiltParams })
                }
              />
            )}
          </PricesWrapper>
        )}
      </Container>
    </>
  );
}

const PriceCardContainer = styled.div`
  position: relative;
  width: min-content;
  height: min-content;
  cursor: pointer;
  .protective-layer {
    position: absolute !important;
    background-color: transparent !important;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    button {
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
    }
  }
`;

const PriceStyle = styled.div`
  width: 15rem;
  height: 12rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  ${({ imageUrl, showTag }) => css`
    background-image: url("${imageUrl}");

    ${showTag &&
    `&::before {
      content: "PREMIUM";
      position: absolute;
      top: 10%;
      left: 100%;
      width: min-content;
      padding: .5rem 1rem;
      transform: rotate(30deg) translate(-50%, 100%);
      background-color: #d97706;
      z-index: 10;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 2px;
    }`}
  `}
`;

function PriceCard({ imageUrl, onClick, isIncludedInPlan, showPremiumTag }) {
  const [showProtectiveLayer, setShowProtectiveLayer] = useState(false);

  return (
    <PriceCardContainer
      onMouseEnter={() =>
        isIncludedInPlan === false && setShowProtectiveLayer(true)
      }
      onMouseLeave={() => {
        isIncludedInPlan === false && setShowProtectiveLayer(false);
      }}
      onClick={() => {
        if (isIncludedInPlan) onClick();
      }}
    >
      <PriceStyle imageUrl={imageUrl} showTag={showPremiumTag} />
      {showProtectiveLayer && (
        <PremiumContentProtectiveLayer
          className="protective-layer"
          showText={false}
          buttonSize={"1"}
          buttonText={"desbloquear"}
        />
      )}
    </PriceCardContainer>
  );
}
